// Renders a "Label: rest" string with the label (up to and including the
// first colon) in bold — used to restore the bold prefixes in translated
// list items where the label and text are stored as a single string.
export default function BoldLabel({ text }: { text: string }) {
  const idx = text.indexOf(':');
  if (idx === -1) return <>{text}</>;
  return (
    <>
      <strong>{text.slice(0, idx + 1)}</strong>
      {text.slice(idx + 1)}
    </>
  );
}
